import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["value"],
  _excluded2 = ["options", "values"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { defaultMemoize } from 'reselect';
import PropTypes from 'prop-types';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import { ALL_OPTION } from './withSelectAllOptions.constants';
import { getOptions, getSelectedValuesWithAll, checkIfAllOptionsSelected, getIndeterminateOptions } from './withSelectAllOptions.helpers';

/**
 * @description This HOC can be used for allowing the user to select all the options available in Select. This adds an onChange interceptor which would
 * basically handle logic of All option. It would also handle adding of all as an option, add in selected values if required and pass it down to Select component.
 * @param {*} WrappedComponent
 */
var withSelectAllOptions = function withSelectAllOptions(WrappedComponent) {
  var WithSelectAllOptions = /*#__PURE__*/function (_PureComponent) {
    _inherits(WithSelectAllOptions, _PureComponent);
    var _super = _createSuper(WithSelectAllOptions);
    function WithSelectAllOptions() {
      var _this;
      _classCallCheck(this, WithSelectAllOptions);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "getOptions", defaultMemoize(getOptions));
      _defineProperty(_assertThisInitialized(_this), "getSelectedValuesWithAll", defaultMemoize(getSelectedValuesWithAll));
      _defineProperty(_assertThisInitialized(_this), "getIndeterminateOptions", defaultMemoize(getIndeterminateOptions));
      _defineProperty(_assertThisInitialized(_this), "handleChange", function (_ref) {
        var selectedValues = _ref.value,
          rest = _objectWithoutProperties(_ref, _excluded);
        var _this$props = _this.props,
          onChange = _this$props.onChange,
          options = _this$props.options,
          values = _this$props.values;
        var wasAllOptionSelected = checkIfAllOptionsSelected(options, values);
        var isAllOptionSelected = _includes(selectedValues, ALL_OPTION.value);
        if (isAllOptionSelected && !wasAllOptionSelected) {
          return onChange(_objectSpread(_objectSpread({}, rest), {}, {
            value: _map(options, 'value')
          }));
        }
        if (!isAllOptionSelected && wasAllOptionSelected) {
          return onChange(_objectSpread(_objectSpread({}, rest), {}, {
            value: EMPTY_ARRAY
          }));
        }
        return onChange(_objectSpread(_objectSpread({}, rest), {}, {
          value: _filter(selectedValues, function (selectedValue) {
            return selectedValue !== ALL_OPTION.value;
          })
        }));
      });
      return _this;
    }
    _createClass(WithSelectAllOptions, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          options = _this$props2.options,
          values = _this$props2.values,
          rest = _objectWithoutProperties(_this$props2, _excluded2);
        var selectedValuesWithAll = this.getSelectedValuesWithAll(options, values);
        var optionsWithAll = this.getOptions(options, values);
        var indeterminateOptions = this.getIndeterminateOptions(options, values);
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, rest, {
          values: selectedValuesWithAll,
          onChange: this.handleChange,
          options: optionsWithAll,
          indeterminateOptions: indeterminateOptions
        }));
      }
    }]);
    return WithSelectAllOptions;
  }(PureComponent);
  WithSelectAllOptions.propTypes = {
    options: PropTypes.array.isRequired,
    values: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
  };
  return WithSelectAllOptions;
};
export default withSelectAllOptions;